import { useEffect, useState } from "react";
import { GenericDialog } from "@/components/shared/GenericDialog";
import * as riskState from '@/components/Analysis/RiskAssessment/state/atoms';
import * as state from '@/components/Analysis/state';
import { useAtom } from "jotai";

import { useGetAssemblyForTaskModalQuery } from "@/__generated__/graphql";
import { NOT_APPLICABLE_LABEL } from "../../../../constants";
import { Box, Typography } from "@mui/material";

export const DescriptionModal = () => {
  const [openDescriptionModal, setOpenDescriptionModal] = useAtom(riskState.openDescriptionModal);
  const [selectedAssemblyId, setSelectedAssemblyId] = useAtom(state.selectedAssemblyId);
  const [description, setDescription] = useState<string>('');
  const handleClose = () => {
    setOpenDescriptionModal(false);
    setSelectedAssemblyId(undefined);
  };

  const { data: assemblyTemplateFieldData, loading: assemblyLoading } =
    useGetAssemblyForTaskModalQuery({
      variables: {
        assemblyId: selectedAssemblyId ?? '',
      },
    });

  useEffect(() => {
    if (assemblyTemplateFieldData?.assembly) {
      const { templateFieldData } = assemblyTemplateFieldData.assembly;
      setDescription(templateFieldData?.risk_description ?? NOT_APPLICABLE_LABEL);
    }
  }, [assemblyTemplateFieldData?.assembly]);


  return (
    <GenericDialog
      open={openDescriptionModal}
      onClose={handleClose}
      showCloseIcon
      title="Description"
      titleStyles={{
        padding: '3.2rem',
        paddingBottom: '2.4rem',
        typography: 'h4',
      }}
      paperStyles={{
        maxWidth: '87rem',
        maxHeight: '50.4rem',
        height: 'fit-content',

      }}
      contentStyles={{
        padding: '3.2rem',
        overflow: 'hidden',
      }}
      content={
        <Box sx={{
          border: '0.1rem solid #DDD',
          borderRadius: '0.4rem',
          padding: '2.4rem',
          maxHeight: '39.2rem',
          overflowY: 'auto',
        }}>
          <Typography variant="body1">
            {assemblyLoading ? 'Loading...' : description}
          </Typography>
        </Box>
      }
      actions={[]}

    />
  );
};
